import React, { useEffect } from 'react';
/**
 * App Initializer
 * Registers all available apps with storytelling-driven navigation
 */
import { Home, Sparkles, Briefcase, Brain, Mail, Settings, Users } from 'lucide-react';
import { useAppRegistry } from '../../core/contexts/AppRegistry';
import { appGradients } from '../../core/constants/themeTokens';
import { SettingsApp } from '../apps/SettingsApp';
import { AboutApp } from '../apps/AboutApp';
import { PortfolioApp } from '../apps/PortfolioApp';
import { StudioApp } from '../apps/StudioApp';
import { ExpertiseApp } from '../apps/ExpertiseApp';
import { ContactApp } from '../apps/ContactApp';
import { HomeApp } from '../apps/HomeApp';
export function AppInitializer() {
  const {
    registerApp
  } = useAppRegistry();
  useEffect(() => {
    // Register apps in storytelling order - About first as entry point
    registerApp({
      id: 'about',
      title: 'About',
      icon: Users,
      color: 'from-emerald-500 to-teal-500',
      route: '/about',
      category: 'main',
      component: AboutApp
    });
    registerApp({
      id: 'studio',
      title: 'Studio',
      icon: Sparkles,
      color: 'from-fuchsia-500 to-violet-500',
      route: '/studio',
      category: 'main',
      component: StudioApp
    });
    registerApp({
      id: 'projects',
      title: 'Projects',
      icon: Briefcase,
      color: 'from-blue-500 to-indigo-500',
      route: '/projects',
      category: 'main',
      component: PortfolioApp
    });
    registerApp({
      id: 'expertise',
      title: 'Expertise',
      icon: Brain,
      color: 'from-purple-500 to-violet-500',
      route: '/expertise',
      category: 'main',
      component: ExpertiseApp
    });
    registerApp({
      id: 'contact',
      title: 'Contact',
      icon: Mail,
      color: 'from-amber-500 to-orange-500',
      route: '/contact',
      category: 'main',
      component: ContactApp
    });
    // Settings as utility (separate from main navigation)
    registerApp({
      id: 'settings',
      title: 'Settings',
      icon: Settings,
      color: 'from-slate-500 to-gray-500',
      route: '/settings',
      category: 'utility',
      component: SettingsApp
    });
  }, [registerApp]);
  return null;
}